module.exports = __webpack_public_path__ + "img/Singapore.6e298a3c.svg";